/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getBannerList: (params) => {
    return axios.get(API_ENDPOINTS.GET_BANNERS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getBannerbyid: (id) => {
    //console.log('url-->',API_ENDPOINTS.GET_BANNERS_DETAILS_BY_ID + "/" + id);
    return axios.get(API_ENDPOINTS.GET_BANNERS_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  addBanner: (data) => {
    return axios.post(API_ENDPOINTS.ADD_BANNERS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data","x-tenant-slug":"default"
      },
    });
  },
  updateBanner: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_BANNERS_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data","x-tenant-slug":"default"
      },
    });
  },
  deleteBanner: (id) => {
    //console.log('url-->',API_ENDPOINTS.DELETE_SERVICE_BY_ID + "/" + id);
    return axios.delete(API_ENDPOINTS.DELETE_BANNERS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
};
